import React from "react";
import { useStyles } from "./styles";

export const StatisticWidgetTitle = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.headerTitle} ref={ref}>
      {children}
    </div>
  );
};
StatisticWidgetTitle.muiName = "StatisticWidgetTitle";
StatisticWidgetTitle.displayName = "StatisticWidgetTitle";

export default StatisticWidgetTitle;
